<template>
    <v-container class="content-container content-container--wide">
        <v-row>
            <v-col>

                <!-- Title -->
                <div class="d-flex justify-space-between align-center">

                    <!-- Page title -->
                    <div class="page-heading">
                        {{ $t(`SeznamPogodb.Title`) }}
                    </div>

                    <!-- Vnos pogodbe btn -->
                    <v-btn @click="GotoVnosPogodbe" flat class="btn btn--primary-fill">
                        Vnos pogodbe
                        <img src="../../assets/images/components/icon-btn-plus-16.svg" alt="Plus" class="ml-2"></img>
                    </v-btn>

                </div>

                <!-- Filters -->
                <v-row class="table-contracts-filters">

                    <!-- Period -->
                    <v-col>
                        <label class="form-label">
                            {{ $t(`SeznamPogodb.VOdobravanju.DateSelection`) }}
                        </label>

                        <!-- Datepicker -->
                        <Datepicker :enableTimePicker="false" autoApply position="right" locale="sl" text-input
                            :minDate="CalculateMonthLimit()" :maxDate="new Date()" range
                            v-model="pogodbeStore.Filters.DateRange" format="dd.MM.yyyy">
                        </Datepicker>

                        <!-- Date selection shortcuts -->
                        <div class="d-flex ga-1 mt-1">
                            <v-chip @click="Today" size="small">Danes</v-chip>

                            <v-chip @click="Yesterday" size="small">Včeraj</v-chip>

                            <v-chip @click="ThisWeek" size="small">Ta teden</v-chip>

                            <v-chip @click="ThisMonth" size="small">Ta mesec</v-chip>

                            <v-chip @click="ThisYear" size="small">To leto</v-chip>
                        </div>

                    </v-col>

                    <!-- Status -->
                    <v-col>
                        <label class="form-label">
                            {{ $t(`SeznamPogodb.VOdobravanju.StatusInput`) }}
                        </label>

                        <v-select multiple variant="outlined" :clearable="true" placeholder="Izberi status"
                            class="filter__status" v-model="pogodbeStore.Filters.Status" item-title="Value"
                            item-value="Key" item-props="AdditionalData" :items="pogodbeStore.getStatusItems()">

                            <!-- Options -->
                            <template v-slot:item="{ props, item }">
                                <v-list-item v-bind="props">
                                    <template v-slot:prepend="{ isSelected }">
                                        <v-list-item-action start>
                                            <v-checkbox-btn :model-value="isSelected">
                                            </v-checkbox-btn>
                                        </v-list-item-action>
                                    </template>
                                    <template v-slot:title>
                                        <span :class="props.classSelection">
                                            {{ item.title }}
                                        </span>
                                    </template>
                                </v-list-item>
                            </template>

                            <!-- Selection -->
                            <template v-slot:selection="{ item, index }">
                                <div :class="item.props.classSelection">
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>

                        </v-select>
                    </v-col>

                    <!-- Poslovalnica -->
                    <v-col>
                        <label class="form-label">
                            {{ $t(`SeznamPogodb.VOdobravanju.Poslovalnica`) }}
                        </label>
                        <v-select v-model="pogodbeStore.Filters.PoslovalnicaFilter" variant="outlined" :clearable="true"
                            placeholder="Izberi poslovalnico" :items="pogodbeStore.PoslovalnicaList"
                            :returnObject="true" item-title="Value" item-value="Key">
                        </v-select>
                    </v-col>

                    <v-col class="d-none d-xl-block"></v-col>

                    <!-- Search -->
                    <v-col>
                        <label class="form-label">
                            {{ $t(`SeznamPogodb.VOdobravanju.SearchInput`) }}
                        </label>
                        <v-text-field v-model="pogodbeStore.Filters.Search" clearable variant="outlined"
                            append-inner-icon="mdi-magnify">
                        </v-text-field>
                    </v-col>

                </v-row>

                <!-- Toolbar -->
                <div class="table-contracts-toolbar">

                    <!-- Vse/za obdelavo/neprebrano/obdelano tabs -->
                    <v-chip-group v-model="pogodbeStore.Filters.ContractTabStatus" mandatory>
                        <v-chip :text="$t(`SeznamPogodb.Filters.ContractTabStatus.${ContractTabStatus.All}`)"
                            size="small" :value="ContractTabStatus.All">
                        </v-chip>

                        <v-chip size="small" :value="ContractTabStatus.ForProcessing" class="chip--badge">
                            {{ $t(`SeznamPogodb.Filters.ContractTabStatus.${ContractTabStatus.ForProcessing}`) }}
                            <v-badge :content="pogodbeStore.PogodbaData.Counts.ForProcessingCount" inline
                                class="badge--primary"
                                :class="pogodbeStore.PogodbaData.Counts.ForProcessingCount > 0 ? '' : 'd-none'"></v-badge>
                        </v-chip>

                        <v-chip size="small" :value="ContractTabStatus.NotRead" class="chip--badge">
                            {{ $t(`SeznamPogodb.Filters.ContractTabStatus.${ContractTabStatus.NotRead}`) }}
                            <v-badge :content="pogodbeStore.PogodbaData.Counts.NotReadCount" inline
                                class="badge--primary"
                                :class="pogodbeStore.PogodbaData.Counts.NotReadCount > 0 ? '' : 'd-none'"></v-badge>
                        </v-chip>

                        <v-chip :text="$t(`SeznamPogodb.Filters.ContractTabStatus.${ContractTabStatus.Processed}`)"
                            size="small" :value="ContractTabStatus.Processed">
                        </v-chip>

                    </v-chip-group>

                    <!-- Refresh loader -->
                    <div :class="pogodbeStore.Helpers.ShowRefreshLoader ? 'loader-small' : 'd-none'">
                        <img src="@assets/images/general/loader-nlb-small.svg" alt="Loader">
                        <div>
                            Osvežujem
                        </div>
                    </div>

                    <div class="d-block d-sm-flex ga-5 align-center justify-space-between ml-lg-auto">

                        <!-- Sort -->
                        <v-chip @click="ToggleSort" size="small">
                            <img src="@assets/images/contract-list/icon-switch-vertical.svg" alt="Sort" class="mr-1" />
                            Sortiraj po: {{
                                $t(`SeznamPogodb.Filters.Sort.${pogodbeStore.Filters.SortDirection}`) }}</v-chip>

                        <div class="d-flex align-center ga-4 justify-end">

                            <!-- Nr. of contracts -->
                            <div class="no-of-contracts">
                                {{ $t(`SeznamPogodb.VOdobravanju.FirstPartText`) }} {{
                                    pogodbeStore.PogodbaData.ContractList.length
                                }}/{{
                                    pogodbeStore.PogodbaData.Counts.ContractCount }}
                                {{ $t(`SeznamPogodb.VOdobravanju.SecondPartText`) }}
                            </div>

                            <!-- Export btn -->
                            <v-btn @click="ExportData" flat class="btn btn--sm btn--primary-outline">
                                {{ $t(`SeznamPogodb.VOdobravanju.BtnExport`) }}
                            </v-btn>

                        </div>

                    </div>

                </div>

                <!-- Contracts -->
                <table class="table-contracts">

                    <!-- Header row -->
                    <thead>
                        <tr>
                            <th class="th"></th>
                            <th class="th">{{ $t(`SeznamPogodb.VOdobravanju.Table.Contract`) }}</th>
                            <th class="th">{{ $t(`SeznamPogodb.VOdobravanju.Table.Status`) }}</th>
                            <th class="th d-none d-md-block">{{ $t(`SeznamPogodb.VOdobravanju.Table.Value`) }}
                            </th>
                            <th class="th d-none d-md-block">{{ $t(`SeznamPogodb.VOdobravanju.Table.Product`) }}
                            </th>
                            <th class="th">{{ $t(`SeznamPogodb.VOdobravanju.Table.Client`) }}</th>
                            <th class="th d-none d-md-block">{{ $t(`SeznamPogodb.VOdobravanju.Table.Office`) }}
                            </th>
                            <th class="th d-none d-md-block">{{ $t(`SeznamPogodb.VOdobravanju.Table.EnteredBy`)
                            }}</th>
                            <th class="th d-none d-sm-block"></th>
                        </tr>

                    </thead>

                    <!-- Table body -->
                    <tbody>

                        <!-- Loader -->
                        <tr v-if="pogodbeStore.Helpers.ShowLoadLoader" class="table-contracts__no-bg">
                            <td class="span-row text-center">
                                <div
                                    :class="pogodbeStore.Helpers.ShowLoadLoader ? 'loader-large--not-fixed my-14' : 'd-none'">
                                    <img src="@assets/images/general/loader-nlb-large.svg" alt="Loader">
                                </div>
                            </td>
                        </tr>

                        <!-- No results -->
                        <tr class="table-contracts__no-bg"
                            v-if="pogodbeStore.PogodbaData.ContractList.length < 1 && !pogodbeStore.Helpers.ShowLoadLoader">
                            <td class="span-row text-center">

                                <div class="my-14">
                                    <span class="no-results">Ni ustrezne pogodbe.</span>
                                </div>

                            </td>
                        </tr>

                        <Pogodba v-for="pogodba in pogodbeStore.PogodbaData.ContractList" :key="pogodba.PogodbaId"
                            @cancel-contract="StornoOpen(pogodba.PogodbaId)"
                            :Pogodba="pogodba" @change="SpecificContract"
                            v-show="!pogodbeStore.Helpers.ShowLoadLoader" />

                        <!-- Show more btn -->
                        <tr v-if="pogodbeStore.PogodbaData.MoreData" class="table-contracts__no-bg">
                            <td class="span-row text-center">
                                <v-btn class="btn btn--primary-fill" @click="LoadMore">
                                    Prikaži več
                                </v-btn>
                            </td>
                        </tr>

                    </tbody>

                </table>

            </v-col>
        </v-row>

        <v-btn v-show="showScrollButton" @click="y = 0;" class="btn btn--primary-fill btn--round btn-scroll-top">
            <img src="@assets/images/contract-list/icon-arrow-up.svg" alt="Arrow up" />
        </v-btn>

    </v-container>
    <div v-if="pogodbeStore.PogodbaData.showEditContract">
        <Modal :display="pogodbeStore.PogodbaData.showEditContract"
            @modalClosed="pogodbeStore.PogodbaData.showEditContract = false" :showAcceptButton="false"
            :showCloseButton="true" closeText="Zapri" class="dialog-side-panel">
            <PogodbeEdit :id="pogodbeStore.PogodbaData.currentContractId.toString()" />
        </Modal>
    </div>
    <Modal :display="pogodbeStore.ESignLater.showPodpis" @modalClosed="pogodbeStore.ESignLater.showPodpis = false"
        :showAcceptButton="false" :showDeclineButton="false" class="dialog-preview">
        <DocumentSigner :url="pogodbeStore.ESignLater.Url" frameBorder="0" />
    </Modal>

    <!-- Modal Storno -->
    <Modal :title="$t(`SeznamPogodb.ModalStorno.Title`)" :display="stornoDisplay"
        @modalClosed="stornoDisplay = false;" :closeText="$t(`SeznamPogodb.ModalStorno.CloseBtn`)"
        :acceptText="$t(`SeznamPogodb.ModalStorno.SaveBtn`)" @accept="ContractStorno()"
        class="modal-summit-comments">
        <div class="">
            <label class="form-label">{{ $t(`SeznamPogodb.ModalStorno.InputLabel`) }}</label>
            <v-textarea v-model="pogodbeStore.PogodbaDetails.StornoComment"
                :error-messages="v2$.StornoComment.$errors[0] != null ? v2$.StornoComment.$errors[0].$message : ''"
                @focus="v2$.StornoComment.$reset" variant="outlined" rows="2">
            </v-textarea>
        </div>

    </Modal>

</template>

<script setup lang="ts">
    import Pogodba from "@views/contract-list/contract.vue";
    import router from "@app/router";
    import { computed, ComputedRef, onUnmounted, Ref, ref, watch } from "vue";
    import { useSeznamPogodbStore, SortDirection, ContractTabStatus, ResetFilters } from "@/app/store/app/contract-list/store";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
    import { useAppStore } from "@/app/store/app/store";
    import Modal from "@/app/components/modal.vue";
    import DocumentSigner from "@components/document-signer.vue";
    import { useWindowScroll } from '@vueuse/core'
    import { onBeforeRouteLeave } from 'vue-router';
    import PogodbeEdit from "./contract-edit.vue";
    import useVuelidate from "@vuelidate/core";
    import { helpers, required } from "@vuelidate/validators";
    import { i18n } from "@/app/i18n";

    const appStore = useAppStore();
    const pogodbeStore = useSeznamPogodbStore();
    const fw4 = useFw4Store();

    const { x, y } = useWindowScroll({ behavior: 'smooth' })
    const showScrollButton: ComputedRef<boolean> = computed(() => y.value > 0)
    let interval: Ref<any> = ref(null);
    let debounceTimeout: NodeJS.Timeout | null = null;
    let stornoDisplay: Ref<boolean> = ref(false);

    function GetLast14Days() {
        const endDate = new Date();
        endDate.setHours(23, 59, 59, 0);

        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 14);
        startDate.setHours(0, 0, 0, 0);

        return [startDate, endDate];
    }

    pogodbeStore.loadPoslovalnica();
    pogodbeStore.Filters.DateRange = GetLast14Days(); // Set default 14-day range

    function ContractListLoad(isRefresh: boolean) {
        if (isRefresh) {
            pogodbeStore.Helpers.ShowRefreshLoader = true;
        }
        else {
            pogodbeStore.Helpers.ShowLoadLoader = true;
        }

        pogodbeStore.getPogodbeSeznam();

        // pogodbeStore.getPogodbeSeznam();

        // Clear interval
        if (interval.value) {
            clearInterval(interval.value);
        }

        // Set a new interval
        interval.value = setInterval(() => {
            ContractListLoad(true);
        }, 60000);
    }

    ContractListLoad(false);

    const ToggleSort = () => {
        pogodbeStore.Filters.SortDirection = pogodbeStore.Filters.SortDirection == SortDirection.Newest ? SortDirection.Oldest : SortDirection.Newest;
    };

    function ExportData() {
        fw4.ExportData(
            {
                MethodName: "ExportPogodbe",
                Parameters: {
                    DateStart: pogodbeStore.Filters.DateRange ? pogodbeStore.Filters.DateRange[0] : null,
                    DateEnd: pogodbeStore.Filters.DateRange ? pogodbeStore.Filters.DateRange[1] : null,
                    Search: pogodbeStore.Filters.Search == null ? "" : pogodbeStore.Filters.Search,
                    PageSize: pogodbeStore.Filters.Pagination.PageSize,
                    PageIndex: pogodbeStore.Filters.Pagination.PageIndex,
                    Status: JSON.stringify(pogodbeStore.Filters.Status),
                    SortDirection: pogodbeStore.Filters.SortDirection,
                    PoslovalnicaFilter: pogodbeStore.Filters.PoslovalnicaFilter == undefined ? -1 : pogodbeStore.Filters.PoslovalnicaFilter.Key,
                    ContractTabStatus: pogodbeStore.Filters.ContractTabStatus
                },
                FileName: ""
            });
    };

    function CalculateMonthLimit(): Date {
        return new Date(2025, 0, 1); // 2025-01-01
    };


    watch(() => pogodbeStore.Filters, () => {
        //če je search naj počaka 3ms
        if (pogodbeStore.Filters.Search) {

            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }

            debounceTimeout = setTimeout(() => {
                ContractListLoad(false);
            }, 600);
        } else {
            // Takoj izvedi, če ni Search filtra
            ContractListLoad(false);
        }
    }, { deep: true });

    function StornoOpen(contractId: number) {
        pogodbeStore.PogodbaDetails.PogodbaId = contractId;
        pogodbeStore.PogodbaDetails.StornoComment = "";
        stornoDisplay.value = true;
    }

    async function ContractStorno() {
        await validateStornoForm().then(() => {
            v2$.value.$reset();
            pogodbeStore.PogodbaStorno()
                .then(() => {
                    pogodbeStore.getPogodbeSeznam();
                    stornoDisplay.value = false;
                });
        });
    }

    // watch(pogodbeStore.Filters, () => {
    //     console.log("IN WATCH");

    //     ContractListLoad(false);

    //     // pogodbeStore.getPogodbeSeznam();

    //     // if (filters.DateRange != null && filters.DateRange.length > 1) {
    //     //     pogodbeStore.getPogodbeSeznam(filters);
    //     // } else {
    //     //     pogodbeStore.getPogodbeSeznam(filters);
    //     // }

    //     // if(filters.Search == undefined || filters.Search == null){
    //     //     filters.Search = '';
    //     // }
    // });


    function LoadMore() {
        pogodbeStore.Filters.Pagination.PageIndex++;
        // pogodbeStore.getPogodbeSeznam(filters);
    };

    function Today() {
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);

        const todayEnd = new Date();
        todayEnd.setHours(23, 59, 59, 0);

        pogodbeStore.Filters.DateRange = [todayStart, todayEnd];
    };

    function Yesterday() {
        const yesterdayStart = new Date();
        yesterdayStart.setDate(yesterdayStart.getDate() - 1);
        yesterdayStart.setHours(0, 0, 0, 0);

        const yesterdayEnd = new Date();
        yesterdayEnd.setDate(yesterdayEnd.getDate() - 1);
        yesterdayEnd.setHours(23, 59, 59, 0);

        pogodbeStore.Filters.DateRange = [yesterdayStart, yesterdayEnd];
    };

    function ThisWeek() {
        const today = new Date();
        const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 1));
        firstDayOfWeek.setHours(0, 0, 0, 0);

        const lastDayOfWeek = new Date(today.setDate(firstDayOfWeek.getDate() + 6));
        lastDayOfWeek.setHours(23, 59, 59, 0);

        pogodbeStore.Filters.DateRange = [firstDayOfWeek, lastDayOfWeek];
    };

    function ThisMonth() {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        firstDayOfMonth.setHours(0, 0, 0, 0);

        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        lastDayOfMonth.setHours(23, 59, 59, 0);
        pogodbeStore.Filters.DateRange = [firstDayOfMonth, lastDayOfMonth];
    };

    function ThisYear() {
        const today = new Date();
        const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
        firstDayOfYear.setHours(0, 0, 0, 0);

        const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
        lastDayOfYear.setHours(23, 59, 59, 0);
        pogodbeStore.Filters.DateRange = [firstDayOfYear, lastDayOfYear];
    };

    function SpecificContract(PogodbaId: number) {
        //    router.push({ name: "pogodba_edit", params: { id: PogodbaId } })
        pogodbeStore.PogodbaData.showEditContract = true;
        pogodbeStore.PogodbaData.currentContractId = PogodbaId;

    };

    async function GotoVnosPogodbe() {
        if (appStore.User.CanAccessContract && (appStore.User.SisbonTraining == 3) && appStore.User.UserDisabled == false) {
            router.push({ name: "posOrder_home" });
        } else if (appStore.User.CanAccessContract && appStore.User.UserDisabled) {
            fw4.ShowMessageBox("Opozorilo", "Vaš dostop do vnosa nove pogodbe je začasno onemogočen. <br /><br />Za ponovno aktivacijo potrebujemo od vašega delodajalca informacijo o upravičenosti do dostopa. Vljudno prosimo, da kadrovska služba ali druga odgovorna oseba v podjetju to informacijo posreduje na e-mail naslov <a href='mailto:prodaja@nlbbuygo.si'>prodaja@nlbbuygo.si</a>.", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Close]
            ])
        } else if (appStore.User.SisbonTraining == 2) {
            await appStore.ContractCreateConsentLog();
            fw4.ShowMessageBox("Opozorilo", "Vaš profil ni več aktiven, saj v zadnjem mesecu niste vnesli pogodbe.<br/ > <br />Postopek ponovne aktivacije je sedaj v teku. Med delovnim časom bo aktivacija zaključena v nekaj minutah, sicer pa najkasneje naslednji delovni dan - takrat lahko nadaljujete z vnosom pogodb.", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Close]
            ])
        }

        else {
            fw4.ShowMessageBox("Opozorilo", "Pred pričetkom sklepanja pogodb je potrebno opraviti obvezno izobraževanje o SISBON.", [
                MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
                { Id: "OK", Caption: "Opravi izobraževanje", Type: MessageBoxButtonType.OK, IsPrimary: true }
            ]).then((buttonId: any) => {
                if (buttonId == "OK") {
                    router.push({ name: "training_home" });
                }
            })
        }
    };

    onUnmounted(() => {
        if (interval.value) {
            clearInterval(interval.value);
        }
    });

    onBeforeRouteLeave((to, from, next) => {
        if (to.name !== 'pogodba_edit') {
            pogodbeStore.Filters = ResetFilters();
        }
        next();
    });

    // storno validation
    async function validateStornoForm(): Promise<void> {
        v2$.value.$touch();
        let formValid = await v2$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules2 = computed(() => ({
        StornoComment: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), required),
        },  
    }));

    const v2$: any = useVuelidate(validationRules2, pogodbeStore.PogodbaDetails);    
</script>